import { render, staticRenderFns } from "./NewGeneralWorkFunctionsDialog.vue?vue&type=template&id=b835b606&"
import script from "./NewGeneralWorkFunctionsDialog.vue?vue&type=script&lang=js&"
export * from "./NewGeneralWorkFunctionsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports